/*
  will filter only markers (airports) having some routes leading to it
  - return new array of visible markers
*/
const filterVisibleMarkers = (markers, routes) => {
  const visibleMarkers = []
  const addedMarkers = []
  for (let i = 0; i < routes.length; i++) {
    for (let j = 0; j < markers.length; j++) {
      if(routes[i].to === markers[j].iata) {
        if(addedMarkers.indexOf(markers[j].iata) <= -1) {
          visibleMarkers.push(markers[j])
          addedMarkers.push(markers[j].iata)
        }
      }
    }
  }

  return visibleMarkers
}

export default filterVisibleMarkers



// WEBPACK FOOTER //
// ./app/utils/filterVisibleMarkers.js